import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../css/AdminServiceCompanyReferralEdit.css';
import { useParams } from "react-router-dom";

function AdminServiceCompanyReferralEdit() {
    const { id } = useParams();
    const [statuses, setStatuses] = useState([]);
    const [serviceCompanyReferral, setServiceCompanyReferral] = useState({});
    const [originalServiceCompanyReferral, setOriginalServiceCompanyReferral] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [buttonState, setButtonState] = useState('No Changes');
    const [error, setError] = useState('');

    useEffect(() => {
        axios.get('/api/admin/service_provider_referral_statuses')
            .then(response => setStatuses(response.data.statuses))
            .catch(error => setError('Error fetching statuses: ' + error));
    }, []);


    useEffect(() => {
        fetchServiceCompanyReferral();
    }, [id]);

    const fetchServiceCompanyReferral = async () => {
        try {
            const response = await axios.get(`/api/admin/service_provider_referral?id=${id}`);
            setServiceCompanyReferral(response.data);
            setOriginalServiceCompanyReferral(response.data);
        } catch (error) {
            console.error('Error fetching serviceCompanyReferral:', error);
        }
    };

    const handleInputChange = (field, value) => {
        const updatedServiceCompanyReferral = { ...serviceCompanyReferral, [field]: value };
        setServiceCompanyReferral(updatedServiceCompanyReferral);

        if (JSON.stringify(updatedServiceCompanyReferral) === JSON.stringify(originalServiceCompanyReferral)) {
            setButtonState('No Changes');
        } else {
            setButtonState('Save Changes');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (buttonState !== 'Save Changes') return;

        setButtonState('Saving');
        setIsSubmitting(true);

        try {
            await axios.put("/api/admin/service_provider_referral", {service_provider_referral: serviceCompanyReferral});
            setOriginalServiceCompanyReferral(serviceCompanyReferral);
            setButtonState('No Changes');
        } catch (error) {
            console.error('Error updating serviceCompanyReferral:', error);
        } finally {
            setIsSubmitting(false);
            fetchServiceCompanyReferral();
        }
    };

    return (
        <div className="adminServiceCompanyReferralEditContainer">
            <h2>Edit Service Company Referral</h2>
            <h4>Last Edited By: {serviceCompanyReferral?.edited_by?.email || "Unknown User"}</h4>
            {error && <div className="adminServiceCompanyReferralEditError">{error}</div>}
            <form className="adminServiceCompanyReferralEditForm" onSubmit={handleSubmit}>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Name:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.name || ''}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        required
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Email:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.email || ''}
                        onChange={(e) => handleInputChange('email', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>DRE Number:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.dre_number || ''}
                        onChange={(e) => handleInputChange('dre_number', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Company Name:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.company_name || ''}
                        onChange={(e) => handleInputChange('company_name', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Contact Name:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.contact_name || ''}
                        onChange={(e) => handleInputChange('contact_name', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Company Phone:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.company_phone || ''}
                        onChange={(e) => handleInputChange('company_phone', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Company Email:</label>
                    <input
                        type="text"
                        value={serviceCompanyReferral?.company_email || ''}
                        onChange={(e) => handleInputChange('company_email', e.target.value)}
                    />
                </div>
                <div className="adminServiceCompanyReferralEditFormGroup">
                    <label>Status:</label>
                    <select
                        value={serviceCompanyReferral?.status || ''}
                        onChange={(e) => handleInputChange('status', e.target.value)}
                    >
                        {statuses.map((status) => (
                            <option value={status.name}>{status.name}</option>
                        ))}
                    </select>
                </div>

                <button
                    type="submit"
                    className={`adminServiceCompanyReferralEditSubmitButton ${
                        buttonState === 'Save Changes' ? 'active' : 'inactive'
                    }`}
                    disabled={buttonState === 'No Changes' || isSubmitting}
                >
                    {buttonState === 'Saving'
                        ? 'Saving...'
                        : buttonState}
                </button>
            </form>
        </div>
    );
}

export default AdminServiceCompanyReferralEdit;
